import apiClient from "@/services/apiClient";

export default {
    data() {
        return {
            ordersApiUrl: process.env.VUE_APP_ORDERS_API_URL
        }
    },
    methods: {
        async getOrder(orderId) {
            const {data} = await apiClient.get(`${this.ordersApiUrl}/${orderId}`);

            return data;
        },
        async getOrders(params) {
            const qs = new URLSearchParams(params);

            const {data} = await apiClient.get(`${this.ordersApiUrl}?${qs}`);

            return data;
        },
        async getOrdersByCustomerId(customerId) {
            const {data} = await apiClient.get(`${this.ordersApiUrl}/customerId/${customerId}`);

            return data;
        },
        async addPrintEntry(orderId, entry) {
            await apiClient.put(`${this.ordersApiUrl}/${orderId}`, entry);
        },
        async updateOrder(orderId, data) {
            return await apiClient.put(`${this.ordersApiUrl}/${orderId}`, data);
        },
        async updateOrderCustomer(orderId, customer) {
            return await apiClient.put(`${this.ordersApiUrl}/${orderId}`, customer);
        },
        async getItemOrders(itemId) {
            const {data} = await apiClient.get(`${this.ordersApiUrl}/item/${itemId}`);

            return data;
        },
        async getItemOrdersCount(itemId) {
            const {data} = await apiClient.get(`${this.ordersApiUrl}/item-count/${itemId}`);

            return data;
        },
        async createOrder(payload = {}) {
            const {data} = await apiClient.post(`${this.ordersApiUrl}/`, payload);

            return data;
        },
        async getShippingOptions(items) {
            const {data} = await apiClient.post(`${this.ordersApiUrl}/shipping/totals`, { items: items });

            return data;
        },
        async removeOrderItem(orderId, itemId, listingId, quantity, reason, stockAffected) {
            const payload = {
                itemId: itemId,
                listingId: listingId,
                quantity: quantity,
                reason: reason,
                isStockAffected: stockAffected
            };

            const {data} = await apiClient.post(`${this.ordersApiUrl}/${orderId}/item/remove`, payload);

            return data;
        },
        async addOrderItem(orderId, itemId, listingId, quantity) {
            const payload = {
                itemId: itemId,
                listingId: listingId,
                quantity: quantity,
            };

            const {data} = await apiClient.post(`${this.ordersApiUrl}/${orderId}/item`, payload);

            return data;
        },
        async addOrderItemStatus(orderId, itemId, listingId, type, reason, quantity, stockAffected, removeStatus = false) {
            const payload = {
                itemId: itemId,
                listingId: listingId,
                type: type,
                reason: reason,
                quantity: quantity,
                isStockAffected: stockAffected,
                removeStatus: removeStatus,
            };

            const {data} = await apiClient.put(`${this.ordersApiUrl}/${orderId}/item/status`, payload);

            return data;
        },
        async emailInvoice(orderId) {
            const {data} = await apiClient.get(`${this.ordersApiUrl}/email/invoice/${orderId}`);

            return data;
        },
        async emailPreviewInvoice(orderId) {
            let email = 'cmoerer@recordsbymail.com';
            
            const {data} = await apiClient.get(`${this.ordersApiUrl}/email/invoice/${orderId}/${email}`);

            return data;
        },

        async refundPayment(payload) {
            const {data} = await apiClient.post(`${this.ordersApiUrl}/payment/refund`, payload);

            return data;
        }
    }
};